import React from 'react';
import styles from './ProfileIncompleteModal.module.css';

export default function ProfileIncompleteModal({ 
  onNavigateToProfile, 
  onClose, 
  userData, 
  formData, 
  educationEntries 
}) {
  
  const isSectionComplete = (sectionName) => {
    // Handle case where userData might be null/undefined
    if (!userData) return false;
    
    switch (sectionName) {
      case 'personal':
        return Boolean(userData.name?.trim() || (userData.firstName?.trim() && userData.lastName?.trim()));
      case 'education':
        if (userData.role === 'professor') {
          return true;
        }
        return educationEntries && educationEntries.some(entry => {
          const hasInstitution = entry.institution?.trim();
          const hasDepartment = entry.department?.trim();
          const hasLevel = entry.level?.trim();
          return hasInstitution && hasDepartment && hasLevel;
        });
      case 'professorInfo':
        return true;
      case 'preferences':
        return Boolean(userData.interests && userData.interests.length > 0);
      case 'resume':
        return userData.role === 'student' ? Boolean(userData.resumeKey?.trim()) : true;
      default:
        return false;
    }
  };

  const getSectionStatusStyle = (sectionName) => {
    const isComplete = isSectionComplete(sectionName);
    return {
      padding: '6px 12px',
      borderRadius: '16px',
      fontSize: '0.85rem',
      fontWeight: '600',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      backgroundColor: isComplete ? '#10B981' : '#EF4444',
      color: 'white',
      fontFamily: "'Nunito', 'Segoe UI', Arial, sans-serif"
    };
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.profileModal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Complete Your Profile</h2>
          <button className={styles.modalClose} onClick={onClose}>×</button>
        </div>
        <div className={styles.modalContent}>
          <div className={styles.messageSection}>
            <p className={styles.mainMessage}>
              Complete your profile before starting your application. Required fields are marked with <span style={{ color: "#EF4444", fontWeight: "bold" }}>*</span>
            </p>
            
            <div className={styles.sectionStatus}>
              <h4>Profile Completion Status:</h4>
              <div className={styles.statusBadges}>
                <span style={getSectionStatusStyle('personal')}>
                  {isSectionComplete('personal') ? '✓ Personal Info' : '✗ Personal Info'}
                </span>
                <span style={getSectionStatusStyle('education')}>
                  {isSectionComplete('education') ? '✓ Education' : '✗ Education'}
                </span>
                <span style={getSectionStatusStyle('preferences')}>
                  {isSectionComplete('preferences') ? '✓ Preferences' : '✗ Preferences'}
                </span>
                {userData.role === 'student' && (
                  <span style={getSectionStatusStyle('resume')}>
                    {isSectionComplete('resume') ? '✓ Resume' : '✗ Resume'}
                  </span>
                )}
              </div>
            </div>

            <div className={styles.benefitsList}>
              <h4>Why complete your profile?</h4>
              <ul>
                <li>🎯 Get personalized position recommendations</li>
                <li>🔍 Improved matching with research opportunities</li>
                <li>⚡ Faster application process</li>
                <li>📈 Better visibility to professors</li>
              </ul>
            </div>
            <p className={styles.timeEstimate}>
              ⏱️ Just 3 quick steps • 2 minutes to complete
            </p>
          </div>
          <div className={styles.modalActions}>
            <button
              type="button"
              className={styles.btnSecondary}
              onClick={onClose}
            >
              Maybe Later
            </button>
            <button
              type="button"
              className={styles.btnPrimary}
              onClick={onNavigateToProfile}
            >
              Complete Profile Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}